import request from "@/api/request";

export function statistics() {
    return request({
        url: '/api/game/statistics',
        method: 'get'
    })
}

export function support(query) {
    return request({
        url: '/api/game/support',
        method: 'get',
        params: query
    })
}

export function getSkinImg(heroId){
    return request({
        url:`https://game.gtimg.cn/images/lol/act/img/js/hero/${heroId}.js`,
        method: 'get',
    })
}

//https://game.gtimg.cn/images/lol/act/img/js/runeList/rune_list.js
